<template>
  <!-- 确认弹窗 -->
  <div>
    <Modal
      width="400"
      :value="showModal"
      class-name="confirmModal"
      :title="title"
      @on-visible-change="visibleChange">
        <!-- 立项审核确认 -->
        <div v-show="title === '立项审核'">
          <Icon type="help-circled" size="40" color="#ff9200"></Icon>
          <span class="text">是否确定参与投标？</span>
          <Input v-model="reason" v-show="noParticipation" placeholder="请填写不参与原因" style="margin-left:44px;width:300px"></Input>
        </div>
        <!-- 项目立项确认 -->
        <div v-show="title === '项目结项'">
          <Icon type="help-circled" size="40" color="#ff9200"></Icon>
          <span class="text">项目投标是否成功？</span>
        </div>
        <div slot="footer">
          <span v-show="title === '立项审核'">
            <Button @click="onCancel">{{noParticipation ? '确定' : '不参与'}}</Button>
            <Button type="primary" v-show="!noParticipation" @click="onOk">参与</Button>
          </span>
          <span v-show="title === '项目结项'">
            <Button type="error" @click="onCancel">失败</Button>
            <Button type="success" @click="onOk">成功</Button>
          </span>
        </div>
    </Modal>
    <Modal
      :value="showTips"
      title="文件上传提示"
      @on-visible-change="(status)=>{$emit('visibleChange',status)}"
      @on-ok="tipFlow">
      <Alert show-icon v-show="tipType==='招标公告'">
        可在文件汇总处上传‘ 邀请函/招标公告附件 ’
        <template slot="desc">注意：点击‘ 确定 ’默认不上传/已上传，流程发起后不可再次上传</template>
      </Alert>
      <Alert show-icon v-show="tipType==='审核意见'">
        可在文件汇总处上传‘ 审核反馈意见 ’
        <template slot="desc">注意：点击‘ 确定 ’默认不上传/已上传</template>
      </Alert>
    </Modal>
    <div v-show="false">
      <fileCollect :formData="form" ref="fileUpload"></fileCollect>
    </div>
  </div>
</template>

<script>
import ajax from "@/lib/ajax"
import requestUrls from "@/lib/requestUrls"
import sendMessage from "@/lib/message"
import fileCollect from "./fileCollect"

export default {
  props: {
    showModal: Boolean,
    showTips: Boolean,
    formData: Object,
    tipType: String
  },
  components: {
    fileCollect
  },
  data() {
    return {
      form: {},
      reason: '',
      noParticipation: false
    }
  },
  computed: {
    title() {
      switch (this.form.project_status) {
        case '立项审核中':
          return '立项审核'
          break
        case '文件审核中':
          return '文件审核'
          break
        case '待结项':
          return '项目结项'
          break
      }
    }
  },
  watch: {
    formData(val) {
      this.form = val
      this.dataFormat()
    }
  },
  methods: {
    dataFormat() {
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== '' && this.form[key] !== null) {
          switch(key) {
            case 'bond':
            case 'budget':
            case 'bid_budget':
            case 'buyer_contact':
            case 'my_offer':
            case 'marginAccount':
              this.form[key] = this.form[key].toString()
            break
            case 'property':
            if (typeof this.form[key] === 'string') {
              this.form[key] = this.form[key].split('+')
            }
          }
        } else {
          if (key === 'property') {
            this.form[key] = []
          }
        }
      })
    },
    visibleChange(status) {
      this.$emit('visibleChange',status)
    },
    reset() {
      this.noParticipation = false
      this.reason = ''
    },
    async dataUpdate(params) {
      let req = JSON.parse(JSON.stringify(params));
      if (req.property) {
        req.property = req.property.join("+");
      }
      let res = await ajax.post(requestUrls.ClBidManage.CreateOrUpdate, {
        clBidManage: req
      })
      return res
    },
    onOk() {
      switch (this.title) {
        case '立项审核':
          this.$emit('visibleChange',false)
          this.$emit('result', '参与')
        break
        case '项目结项':
          if (!this.form.contract_date || !this.form.contract_date2) {
            this.$Message.info('请前往“ 基本信息 ”完善信息填写')
            return
          }
          this.$refs.fileUpload.getHistory(this.formData.id)
          let type5 = this.$refs.fileUpload.type5  // 中标通知书
          setTimeout(() => {
            if (type5.length !== 1) {
              this.$emit('visibleChange',false)
              this.$emit('result', '投标成功')
            } else {
              this.$Message.info('请前往“ 文件汇总 ”上传中标通知书/框架协议')
            }
          }, 500)
        break
      }
    },
    onCancel() {
      switch (this.title) {
        case '立项审核':
          this.noParticipation = true
          if (this.reason) {
            this.$emit('visibleChange',false)
            this.$emit('result', '不参与', this.reason)
          } else {
            this.$Message.info('请填写原因！')
          }
          break
        case '项目结项':
          this.$emit('visibleChange',false)
          this.$emit('result', '投标失败')
          break
      }
    },
    continueFlow() {
      this.$Message.success('确定参与投标')
      // 信息通知
      let principal = [this.form.principal,'李柱']
      principal.forEach(el => {
        let messageParams = {
          appId: "1005",
          uniqueId: el, // 用户名
          contentJson: {
            title: "投标管理",
            subTitle: "立项审核",
            description: el === this.form.principal ? `项目：${this.form.project_name} 立项审核通过，请上传报名资料` : `项目：${this.form.project_name} 已确认参与投标`,
            url: "http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2"
          }
        };
        sendMessage("wechat", messageParams)
      })
    },
    cancelFlow() {
      this.$Message.info("已确定不参与投标")
      // 信息通知
      let principal = [this.form.principal,'李柱']
      principal.forEach(el => {
        let messageParams = {
          appId: "1005",
          uniqueId: el, // 用户名
          contentJson: {
            title: "投标管理",
            subTitle: "立项审核",
            description: `项目：${this.form.project_name} 立项审核不通过，原因为:${this.form.participationReason}`,
            url: "http://qy.chinapsp.cn:8884?qyLogin#/customerManage/tbgl2"
          }
        };
        sendMessage("wechat", messageParams)
      })
    },
    tipFlow() {
      if(this.tipType==='招标公告') {
        this.$emit('appendix')
      } else {
        this.$emit('auditMind')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.confirmModal {
  .ivu-modal-body {
    padding-top: 0;
  }
  .ivu-modal-header,
  .ivu-modal-footer {
    border: 0;
  }
  .text {
    display: inline-block;
    line-height: 40px;
    vertical-align: bottom;
    margin-left: 10px;
  }
}
</style>
